import { useEffect, useMemo, useState } from "react";

import LC from "..";

import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";

import { useFieldPrefix, useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import FormRow from "components/form/FormRow";
import { Field, useForm } from "react-final-form";
import BasicAccordion from "components/basic/BasicAccordion";
import FormContent from "components/form/FormContent";
import DateInput from "components/form/input/DateInput";
import { Autocomplete, TextField } from "@mui/material";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Variedade from "entity/Variedade";

export default function LCEditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(LC, "Manual", TipoClass), [visita.cliente]);
    const [apontamento] = useFieldValue();
    const form = useForm();

    const [talhoes, setTalhoes] = useState([]);
    const talhaoFieldName = useFieldPrefix("talhao");

    useEffect(() => {
        if (tipo !== "Manual") {
            setTipo("Manual");
        }
    }, [setTipo, tipo]);

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = LC.calcConformidade(apontamento, params);
            form.change("conformidade", LC.calcConformidade(apontamento, params));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    useEffect(() => {
        if (visita.fazenda && visita.fazenda.data.talhoesFazenda) {
            setTalhoes(["", ...visita.fazenda.data.talhoesFazenda]);
        }
    }, [visita.fazenda]);

    return (
        <>
            <BasicAccordion title="Dados Básicos" defaultExpanded={true} fullWidth disableGutters>
                <FormContent>
                    <FormRow>
                        <DateInput showTime name="date" label="Data / Hora Coleta" disabled />
                    </FormRow>
                    <FormRow>
                        <Field
                            name={talhaoFieldName}
                            validate={(value) => (value && value.length > 0 ? undefined : "Campo obrigatório")}
                            render={({ input, meta }) => (
                                <div style={{ flex: 1 }}>
                                    <Autocomplete
                                        // multiple={input.value?.length ? true : false}
                                        multiple={!input.value || input.value.length ? true : false}
                                        value={input.value || []}
                                        onChange={(_, value) => input.onChange(value)}
                                        options={talhoes}
                                        getOptionLabel={(option) => option.nome || ""}
                                        isOptionEqualToValue={(option, value) => option.nome === value.nome}
                                        sx={{ flex: 1 }}
                                        renderInput={(params) => (
                                            <TextField
                                                label="Talhão"
                                                variant="standard"
                                                {...params}
                                                error={meta.error && meta.touched}
                                                helperText={meta.touched ? meta.error : ""}
                                            />
                                        )}
                                        renderOption={(props, option) => <li {...props}>{option.nome}</li>}
                                    />
                                    {/* {meta.error && meta.touched && (
                                        <span style={{ color: 'red' }}>{meta.error}</span>
                                    )} */}
                                </div>
                            )}
                        />
                    </FormRow>
                </FormContent>
            </BasicAccordion>

            <ApontamentoAmostraParams tipoFixedValue="Manual">
                <FormRow>
                    <EntitySearchInput name="variedade" label="Variedade" EntityClass={Variedade} />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="M. P. A. (m):">{params.metroPontoAvaliado}</ApontamentoParamItem>
                        <ApontamentoParamItem label="Max. Adultas:">{params.metaMaxAdultas}</ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta Ninfas(QT/M):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="numNinfas" label="Nº de Ninfas" />
                <TextInput type="number" name="numAdultas" label="Nº de Adultas" />
                {/* <TextInput type="number" name="numOcorrencias" label="Total" disabled /> */}
                {/* <TextInput name="conforme" label="Conforme" disabled /> */}
            </ApontamentoColetas>
            <ApontamentoResultado conformidadeLabel="Ninfas/Metro">
                {/* <FormRow>
                    <TextInput name="numNinfasMetro" label="Ninfas/Metro" disabled />
                </FormRow> */}
                <FormRow>
                    <TextInput name="numAdultasMetro" label="Adultas/Metro" disabled />
                </FormRow>
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
